import { type TFunction } from '../../contexts/translation-context';
import { type CheckboxGroupFieldOptions } from '../../inputs/checkbox-group-input/checkbox-group-input-props';

export const OTHER_ID = 'Other';

const getValueIncludesOther = (value: string[], optionsNames: string[]) =>
  value.some((_value) => !optionsNames.includes(_value));

export const getIsOtherOptionSelected = (
  value: string[],
  optionsNames: string[],
) => value.length > 0 && getValueIncludesOther(value, optionsNames);

export const getOtherLabel = (addOtherLabel?: string, t?: TFunction) => {
  const otherLabelDefault = t?.('add-other.default-other-option-label');
  return addOtherLabel || otherLabelDefault || OTHER_ID;
};

export const getOtherValue = (value: string[], addOtherLabel?: string) => {
  const addedSymbolsLength = 2; // we add ': ' to other value
  const otherLabelLength = addOtherLabel
    ? addOtherLabel.length + addedSymbolsLength
    : 0;

  const otherItem =
    value.find((item) => item.startsWith(`${addOtherLabel}: `)) || '';
  return otherItem.slice(otherLabelLength);
};

export const getOptionsNames = (options: CheckboxGroupFieldOptions[]) =>
  options.map((option) => option.label);

export const getOptionsValues = (options: CheckboxGroupFieldOptions[]) =>
  options.map((option) => option.value ?? option.label);
